import { render, staticRenderFns } from "./badgeExample.vue?vue&type=template&id=6990a934&scoped=true"
import script from "./badgeExample.vue?vue&type=script&lang=js"
export * from "./badgeExample.vue?vue&type=script&lang=js"
import style0 from "./badgeExample.vue?vue&type=style&index=0&id=6990a934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990a934",
  null
  
)

export default component.exports